import React from 'react';
import { useLoading } from '../contexts/LoadingContext';
import './GlobalLoadingSpinner.css';

const GlobalLoadingSpinner = () => {
  const { isLoading, loadingMessage } = useLoading();

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
      
      {/* Spinner Container */}
      <div className="relative bg-white rounded-xl p-8 shadow-2xl flex flex-col items-center gap-4">
        {/* Spinner */}
        <div className="relative">
          <div className="w-12 h-12 border-4 border-[var(--color-primary)] border-t-transparent rounded-full animate-spin"></div>
          <div className="absolute inset-0 w-12 h-12 border-4 border-transparent border-l-[var(--color-primary)] rounded-full animate-spin animation-delay-150"></div>
          <div className="absolute inset-0 w-12 h-12 border-4 border-transparent border-b-[var(--color-primary)] rounded-full animate-spin animation-delay-300"></div>
        </div>
        
        {/* Loading Text */}
        <div className="text-center">
          <p className="text-lg font-semibold text-[var(--color-text-strong)] mb-2">
            Processing...
          </p>
          {loadingMessage && (
            <p className="text-sm text-[var(--color-text-muted)] max-w-xs text-center">
              {loadingMessage}
            </p>
          )}
        </div>
        
        {/* Progress Dots */}
        <div className="flex gap-1">
          <div className="w-2 h-2 bg-[var(--color-primary)] rounded-full animate-bounce animation-delay-0"></div>
          <div className="w-2 h-2 bg-[var(--color-primary)] rounded-full animate-bounce animation-delay-150"></div>
          <div className="w-2 h-2 bg-[var(--color-primary)] rounded-full animate-bounce animation-delay-300"></div>
        </div>
      </div>
    </div>
  );
};

export default GlobalLoadingSpinner;
